import Vue from 'vue';
import Meta from 'vue-meta';
import routes from '@/router/routes';
import Router from 'vue-router';
import store from '@/store/index';

Vue.use(Meta);
Vue.use(Router);

async function beforeEach(to, from, next) {
    store.dispatch('loading/start');
    if(to.meta.noauth) {
        next();
    } else {
        if (!store.getters['auth/check']) {
            next({name: 'login'})
        } else {
            next()
        }
    }
}

async function afterEach(to, from, next) {
    store.dispatch('loading/stop');
}

/**
 * Scroll Behavior
 *
 * @link https://router.vuejs.org/en/advanced/scroll-behavior.html
 *
 * @param  {Route} to
 * @param  {Route} from
 * @param  {Object|undefined} savedPosition
 * @return {Object}
 */
function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition;
    }

    if (to.hash) {
        return {selector: to.hash};
    }

    const [component] = router.getMatchedComponents({...to}).slice(-1);

    if (component && component.scrollToTop === false) {
        return {};
    }

    return {x: 0, y: 0};
}

/**
 * Create a new router instance.
 *
 * @return {Router}
 */
function createRouter() {
    const router = new Router({
        scrollBehavior,
        mode: 'history',
        routes
    });

    router.beforeEach(beforeEach);
    router.afterEach(afterEach);

    return router;
}

const router = createRouter();

export default router;